<template>
  <div>
    <div
      class="search_result offers_search_result"
      :key="'offer_' + offer.id"
      v-for="offer in results"
    >
      <div dir="ltr" class="is-flex is-align-items-center is-justify-content-flex-end">
        <div class="is-flex is-align-items-center">
          <link-entity :payload="offer" :additional_data="{ resource_type: 'Offer' }">Offer</link-entity>
          <p>(ID: {{ offer.id }}):&nbsp;</p>
        </div>
        <div class="horizontal_space"></div>
        <link-entity :payload="offer.applicant"></link-entity>
        <div class="horizontal_space"></div>
        <link-entity :payload="offer.position.company"></link-entity>
        <div class="horizontal_space"></div>
        <link-entity :payload="offer.position" :additional_data="{ resource_type: 'Position' }"></link-entity>
      </div>
      <br />
      <p>
        <OfferStatus :payload="offer"/>
      </p>
    </div>
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'
import TimeHelper from '@/custom/classes/time_helper.js'
import OfferStatus from '@/components/OfferStatus.vue'
export default {
  name: 'search-modal-offers',
  props: ['results'],
  data () {
    return {
      time_helper: new TimeHelper()
    }
  },
  components: {
    LinkEntity,
    OfferStatus
  }
}
</script>
<style scoped>
  .search_result {
    cursor: auto !important;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
</style>
